import SortingDesktop from './SortingDesktop';

export default SortingDesktop;
